import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/1.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { motion } from "framer-motion";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from "react";




export const Contact = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);

  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  }
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Enviar');
  const [status, setStatus] = useState({});
  const [formSent, setFormSent] = useState(false);


  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault(); // Evita la recarga de la página al enviar el formulario.
  
    setButtonText("Enviando...");
  
    const webhookUrl = "https://hook.us2.make.com/vbmd413usdvzitnnewtby9cml77capsm";
  
    try {
      let response = await fetch(webhookUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(formDetails),
      });
  
      setButtonText("Enviar");
  
      if (response.ok) {
        setFormDetails(formInitialDetails); // Resetea el formulario.
        setStatus({ success: true, message: '¡Gracias por contactarnos! Te responderemos en breve.' });
  
        // Ocultar el formulario
        setFormSent(true);
  
        // Reaparecer el formulario después de 5 segundos
        setTimeout(() => {
          setStatus({});
          setFormSent(false);
        }, 5000);
      } else {
        setStatus({ success: false, message: 'Error al enviar el mensaje. Inténtalo nuevamente.' });
      }
    } catch (error) {
      console.error("Error al enviar datos al webhook:", error);
      setButtonText("Enviar");
      setStatus({ success: false, message: 'Error al enviar el mensaje. Verifica tu conexión e intenta nuevamente.' });
    }
  };
  

  const [hasAnimated, setHasAnimated] = useState(false);

  return (
    <section className="contact" id="connect" style={{ minHeight: "100vh" }}>
      <Container>
        <Row className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
          <Col size={12} md={8}>
            <TrackVisibility>
              {({ isVisible }) => {
                if (isVisible && !hasAnimated) {
                  setHasAnimated(true); // Marcar como animado
                }
  
                return (
                  hasAnimated && (
                    <div data-aos="fade-left">
                      <h2 style={{ textAlign: "center", fontSize: "32px" }}>Solicitar Presupuesto</h2>
  
                      {formSent ? (
                        <div className="success-box">
                          <p>{status.message}</p>
                        </div>
                      ) : (
                        <form onSubmit={handleSubmit}>
                          <Row>
                            <Col size={12} sm={6} className="px-1">
                              <input
                                type="text"
                                value={formDetails.firstName}
                                placeholder="Nombre"
                                onChange={(e) => onFormUpdate("firstName", e.target.value)}
                              />
                            </Col>
                            <Col size={12} sm={6} className="px-1">
                              <input
                                type="text"
                                value={formDetails.lastName}
                                placeholder="Apellido"
                                onChange={(e) => onFormUpdate("lastName", e.target.value)}
                              />
                            </Col>
                            <Col size={12} sm={6} className="px-1">
                              <input
                                type="email"
                                value={formDetails.email}
                                placeholder="Correo Electrónico"
                                onChange={(e) => onFormUpdate("email", e.target.value)}
                              />
                            </Col>
                            <Col size={12} sm={6} className="px-1">
                              <input
                                type="tel"
                                value={formDetails.phone}
                                placeholder="Celular"
                                onChange={(e) => onFormUpdate("phone", e.target.value)}
                              />
                            </Col>
                            <Col size={12} className="px-1">
                              <textarea
                                rows="6"
                                value={formDetails.message}
                                placeholder="¿En qué te gustaría que trabajemos juntos?"
                                onChange={(e) => onFormUpdate("message", e.target.value)}
                              ></textarea>
                              <button type="submit" style={{ display: "block", margin: "20px auto" }}>
                                <span>{buttonText}</span>
                              </button>
                            </Col>
                            {status.message && (
                              <Col>
                                <p className={status.success ? "success-message" : "danger"}>{status.message}</p>
                              </Col>
                            )}
                          </Row>
                        </form>
                      )}
                    </div>
                  )
                );
              }}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
  
}